export type AuthorizationResponse = {
  accessToken: string;
  refreshToken: string;
};

export const LocalStorageAccessTokenKey = 'AccessToken' as const;
export const LocalStorageRefreshTokenKey = 'RefreshToken' as const;

export const getAccessToken = (): string | null =>
  localStorage.getItem(LocalStorageAccessTokenKey);
export const getRefreshToken = (): string | null =>
  localStorage.getItem(LocalStorageRefreshTokenKey);
export const saveAccessToken = (value: string) =>
  localStorage.setItem(LocalStorageAccessTokenKey, value);
export const saveRefreshToken = (value: string) =>
  localStorage.setItem(LocalStorageRefreshTokenKey, value);
export const clearAuthorizationToken = () => {
  localStorage.removeItem(LocalStorageAccessTokenKey);
  localStorage.removeItem(LocalStorageRefreshTokenKey);
};
